import type { RouteLocationNormalized } from '#vue-router'

export const useLoadTypeCommunity = () => {
  const communitiesStore = useCommunitiesStore()
  const crossContentStore = useCrossContentStore()

  return async (route: RouteLocationNormalized) => {
    // no endpoint validates a type: check it against the menu loaded by the global fetch middleware
    // (skipped when that menu is missing, so a cross content failure does not turn every type into a 404)
    const types = crossContentStore.communitiesMenu?.types
    if (types && !types.some((type) => type.slug === route.params.typeName)) {
      throw createError({ statusCode: 404 })
    }

    try {
      await Promise.all([
        communitiesStore.fetchTypeCommunities({
          page: getPageQuery(route),
          type: route.params.typeName as string,
          limit: 60,
          search: '',
        }),
      ])

      if (communitiesStore.getTypePagesCount === -1) {
        return navigateTo(route.path, { replace: true })
      }
    } catch (error) {
      console.error('from page', error)
    }
  }
}
